import { createAsyncThunk } from "@reduxjs/toolkit";
import { openMessage } from "../slice/messageSlice";
import { API_MASTER } from "../../constants";

export const getSitesPage = createAsyncThunk(
  "sites/page",
  async (param, thunkAPI) => {
    let filter = `siteName=${param.filter[0].siteName}`
    const respone = await fetch(
      `${API_MASTER}/api/sites/page?${filter}&size=${param.size}&page=${param.page}`,
      // ?page=${param.page}&size=${param.size}&sort=${param.select},${param.sort}&${param.select}=${param.filter}
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + param.token,
          //    + param.token,
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Credentials": "true",
        }),
      }
    );
    if (respone.status === 200) {
      const responeResult = await respone.json();
      // console.log("as")
      return responeResult;
    } else {
      return {
        data: {
          content: [],
          totalElements: 0,
          totalPages: 0,
          last: true,
          size: 0,
          number: 0,
          numberOfElements: 0,
          first: true,
          empty: false,
        },
      };
    }
  }
);
export const getSitesById = createAsyncThunk(
  'sites/byId',
  async (param, thunkAPI) => {
    const respone = await fetch(`${API_MASTER}/api/sites/${param.id}`, {
      method: 'get',
      headers: new Headers({
        Authorization: 'Bearer ' + param.token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
      }),
    })
    const responeResult = await respone.json()
    // console.log("as")
    if(respone.status === 200){
      return responeResult
    }
    return {data: ''}
  },
)

export const getSitesList = createAsyncThunk(
  'sites/list',
  async (param, thunkAPI) => {
    const respone = await fetch(`${API_MASTER}/api/sites/list`, {
      method: 'get',
      headers: new Headers({
        Authorization: 'Bearer ' + param.token,
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
      }),
    })
    const responeResult = await respone.json()
    // console.log("as")
    return responeResult
  },
)

export const postSites = createAsyncThunk('site/post', async (param, thunkAPI) => {
  // console.log(param);
  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + param.token ,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    },
    body: JSON.stringify(param.data),
  }
  let response = await fetch(`${API_MASTER}/api/sites`, requestOptions)
  if (response.status === 200) {
    thunkAPI.dispatch(
      openMessage({ message: 'Insert Sites Successfull', type: 'success', open: true }),
    )
    thunkAPI.dispatch(getSitesPage(param))
  }
  // .then(getApi())
}
);

export const editSites = createAsyncThunk('sites/update', async (param, thunkAPI) => {
  console.log(param.id);
  console.log(param.data)
  const requestOptions = {
    method: 'PUT',  
    headers: {
      Authorization: 'Bearer ' + param.token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    },
    body: JSON.stringify(param.data),
  }
  let response = await fetch(`${API_MASTER}/api/sites/${param.id}`, requestOptions)
  if (response.status === 200) {
    thunkAPI.dispatch(
      openMessage({ message: 'Berhasil Mengubah Sites', type: 'success', open: true }),
    )
    thunkAPI.dispatch(getSitesPage(param))
  }
  if (response.status === 400) {
    thunkAPI.dispatch(openMessage({ message: 'Edit Sites Failed', type: 'danger', open: true }))
  }
});

export const deleteSites = createAsyncThunk('sites/delete', async (param, thunkAPI) => {
  // console.log(param);
  const requestOptions = {
    method: 'Delete',
    headers: {
      Authorization: 'Bearer ' + param.token,
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
    },
    body: JSON.stringify(param.data),
  }
  let response = await fetch(`${API_MASTER}/api/sites/${param.id}`, requestOptions)
  if (response.status === 200) {
    // thunkAPI.dispatch(openForm({ state: 'delete', open: false, id: '', data: [] }))
    thunkAPI.dispatch(
      openMessage({ message: 'Delete Sites Successfull', type: 'success', open: true }),
    )
    thunkAPI.dispatch(getSitesPage(param))
  }
  // .then(getApi())
})
